import SonyaManips from "../../../../src/components/Suikoden/SonyaManip";
import SonyaData from "../../../../src/lib/Suikoden/Sonya/108Glitchless.js";
import React from 'react';
export default {
  SonyaManips,
  SonyaData,
  React
};